import throttle from 'lodash/throttle'
import refs from '../helpers/refs'

class CMobileNav {
  constructor (el) {
    this.nav = el
    this.$refs = refs(this.nav)
    this.menuHeights = {}
    this.init()
  }

  init () {
    document.addEventListener('mobileMenu:open', () => {
      this.openNav()
    })

    document.addEventListener('mobileMenu:close', () => {
      this.closeNav()
    })

    if (this.$refs.navItems) {
      const updateNavItems = (item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()

          const menu = item.getAttribute('data-menu')
          this.toggleMenu(menu)
        })
      }

      if (this.$refs.navItems.length) {
        this.$refs.navItems.forEach(updateNavItems)
      } else {
        updateNavItems(this.$refs.navItems)
      }
    }

    window.addEventListener(
      'resize',
      throttle(this.handleWindowResize.bind(this), 100)
    )
    this.computeMenuHeights()

    if (this.$refs.recipeImage) {
      this.$refs.recipeImage.addEventListener('load', () => {
        this.computeMenuHeights()
      })
    }

    // Char-Griller currently not set up for i18n, check for existence of locales
    if (this.$refs.localeButton) {
      this.$refs.localeButton.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.toggleLocaleMenu()
      })
    }
  }

  openNav () {
    this.nav.classList.add('c-mobile-nav--active')
  }

  closeNav () {
    this.nav.classList.remove('c-mobile-nav--active')
    this.closeAllMenus()
    this.closeLocaleMenu()
  }

  handleWindowResize () {
    this.closeAllMenus()
    this.closeLocaleMenu()
    this.computeMenuHeights()
  }

  computeMenuHeights () {
    this.menuHeights = {}

    this.$refs.menus.forEach((menu) => {
      const name = menu.getAttribute('data-menu')

      this.menuHeights[name] = menu.scrollHeight
    })
  }

  getNavItem (name) {
    return this.$refs.navItems.find((item) => {
      return item.getAttribute('data-menu') === name
    })
  }

  toggleMenu (name) {
    this.$refs.menus.forEach((menu) => {
      const handle = menu.getAttribute('data-menu')

      if (name === handle) {
        if (menu.classList.contains('c-mobile-nav__menu--active')) {
          menu.style.height = '0px'
          menu.classList.remove('c-mobile-nav__menu--active')
          this.getNavItem(handle).classList.remove(
            'c-mobile-nav__item--active'
          )
        } else {
          menu.style.height = `${this.menuHeights[handle]}px`
          menu.classList.add('c-mobile-nav__menu--active')
          this.getNavItem(handle).classList.add('c-mobile-nav__item--active')
        }
      }
    })
  }

  toggleLocaleMenu () {
    // Char-Griller currently not set up for i18n, check for existence of locales
    if (!this.$refs.locales) {
      return
    }

    if (
      this.$refs.locales.classList.contains('c-mobile-nav__locales--active')
    ) {
      this.$refs.locales.classList.remove('c-mobile-nav__locales--active')
      this.$refs.localeButton.classList.remove(
        'c-mobile-nav__locale-button--active'
      )
    } else {
      this.$refs.locales.classList.add('c-mobile-nav__locales--active')
      this.$refs.localeButton.classList.add(
        'c-mobile-nav__locale-button--active'
      )
    }
  }

  closeLocaleMenu () {
    // Char-Griller currently not set up for i18n, check for existence of locales
    if (!this.$refs.locales) {
      return
    }

    this.$refs.locales.classList.remove('c-mobile-nav__locales--active')
    this.$refs.localeButton.classList.remove(
      'c-mobile-nav__locale-button--active'
    )
  }

  closeAllMenus () {
    this.$refs.menus.forEach((menu) => {
      menu.style.height = '0px'
      menu.classList.remove('c-mobile-nav__menu--active')
    })

    if (this.$refs.navItems) {
      if (this.$refs.navItems.length) {
        this.$refs.navItems.forEach((item) => {
          item.classList.remove('c-mobile-nav__item--active')
        })
      } else {
        this.$refs.navItems.classList.remove('c-mobile-nav__item--active')
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-mobile-nav]')
    .forEach(el => new CMobileNav(el))
})
